export default __webpack_public_path__ + "static/media/drone.eb73a3b1.fbx";